import AppInput from '@nxsys/components/AppInput';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import { Form } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import StepCard from './StepCard';

interface AddJobTitleProps {
  stepNumber: number;
  jobTitle?: string | null;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddJobTitleValues = {
  jobTitleValue: string;
};

const AddJobTitle: React.FC<AddJobTitleProps> = ({
  stepNumber,
  jobTitle,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddJobTitleValues>();
  const { messages } = useIntl();

  const onFinish = (values: AddJobTitleValues) => {
    const params = {
      jobDescription: values?.jobTitleValue ?? null,
    };
    onSubmitStep(params);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addJobTitle'] as string}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          jobTitleValue: jobTitle ?? '',
        }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['common.jobTitle'] as string}
          name="jobTitleValue"
          rules={[
            {
              required: true,
              message: messages['validation.jobTitleRequired'] as string,
            },
          ]}
        >
          <AppInput
            placeholder={`${messages['form.enter'] as string} ${
              messages['common.jobTitle'] as string
            }`}
          />
        </Form.Item>
      </AppFormContainer>
    </StepCard>
  );
};

export default AddJobTitle;
